export default __webpack_public_path__ + "static/media/big-logo.fe1104dd.png";